import styled from '@emotion/styled'
import { colors, size } from '@styles/theme'
import { Emoji } from 'emoji-picker-react'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  flex-shrink: 0;
`

/*
emoji='1f60e'
title='Browsing'

emoji='1f440'
title='Right Now'

emoji='1f91d'
title='Meetup'

emoji='1f4ac'
title='Chatting'

emoji='1f496'
title='Romance'
*/

// const emojis = {
//   browsing: '1f60e',
//   right_now: '1f440',
//   meetup: '1f91d',
//   chatting: '1f4ac',
//   romance: '1f496',
// }

const statusMap = {
  browsing: 'browsing',
  right_now: 'looking',
  meetup: 'handshake',
  chatting: 'chat',
  romance: 'heart',
}

const StatusIcon = ({ status='browsing', size='1rem', ...rest }) => {
  return (
    <img
      src={`https://mandrake-app.b-cdn.net/dev/application/icons/${statusMap[status]}.png`}
      style={{
        height: size,
        width: size,
      }}
      {...rest}
    />
  )
}

const StatusIndicator = ({ status='browsing', size='1rem', emojiSize='60%', containerStyles={} }) => {
  if (!statusMap[status]) return;
  return (
    <Container
      style={{
        backgroundColor: colors.statusColors[status]('primary'),
        height: size,
        width: size,
        ...containerStyles,
      }}>
      <StatusIcon
        status={status}
        size={emojiSize}
      />
    </Container>
  )
}

export default StatusIndicator

export { StatusIcon }
